var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.00003C0.5 2.96246 2.96243 0.500031 6 0.500031H54C57.0376 0.500031 59.5 2.96247 59.5 6.00003V34C59.5 37.0376 57.0376 39.5 54 39.5H6C2.96244 39.5 0.5 37.0376 0.5 34V6.00003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.00003C0.5 2.96246 2.96243 0.500031 6 0.500031H54C57.0376 0.500031 59.5 2.96247 59.5 6.00003V34C59.5 37.0376 57.0376 39.5 54 39.5H6C2.96244 39.5 0.5 37.0376 0.5 34V6.00003Z",
    stroke: "#f4fdfa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1309 28.786H34.866V11.214H25.1309V28.786Z",
    fill: "#FF5F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7512 20C25.7487 18.3095 26.1298 16.6404 26.8659 15.1185C27.602 13.5966 28.6739 12.2616 30.0007 11.214C28.3522 9.91826 26.3723 9.11246 24.2874 8.88873C22.2026 8.66499 20.0968 9.03233 18.2108 9.94878C16.3249 10.8652 14.7348 12.2938 13.6223 14.0712C12.5099 15.8486 11.9199 17.9032 11.9199 20C11.9199 22.0969 12.5099 24.1514 13.6223 25.9288C14.7348 27.7063 16.3249 29.1348 18.2108 30.0513C20.0968 30.9677 22.2026 31.3351 24.2874 31.1113C26.3723 30.8876 28.3522 30.0818 30.0007 28.7861C28.674 27.7384 27.6022 26.4033 26.8662 24.8815C26.1301 23.3596 25.7489 21.6906 25.7512 20Z",
    fill: "#EB001B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 20C48.0115 22.0925 47.432 24.1458 46.3283 25.9236C45.2245 27.7013 43.6414 29.1314 41.7609 30.0493C39.8804 30.9672 37.779 31.3356 35.6984 31.1121C33.6179 30.8886 31.6426 30.0824 30 28.7861C31.3249 27.7367 32.3953 26.4014 33.1312 24.8799C33.8671 23.3584 34.2493 21.6901 34.2493 20C34.2493 18.3099 33.8671 16.6417 33.1312 15.1202C32.3953 13.5987 31.3249 12.2633 30 11.214C31.6426 9.9177 33.6179 9.11143 35.6984 8.88795C37.779 8.66447 39.8804 9.03285 41.7609 9.95074C43.6414 10.8686 45.2245 12.2987 46.3283 14.0765C47.432 15.8543 48.0115 17.9075 48 20Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard_logo.5c4db13ce5760c62327ef83e4bac8f0a.svg";
export { ForwardRef as ReactComponent };